
import type { Recruiter } from "../types";

export const recruiters: Recruiter[] = [
  { id: 1, name: "Sarah Johnson" },
  { id: 2, name: "David Chen" },
  { id: 3, name: "Maria Rodriguez" },
  { id: 4, name: "James Wilson" }
];
